import type {
  SYSColumnDef,
  SYSTableDef,
} from "../../../../../_ovlclient/src/library/table/tableapi"

export type UserAdministration_UserRoleType = {
  Id?: number
  U_CntctCode?: number
  Grp?: string
  U_RoleCode?: string
  U_RoleDesc?: string
  U_Val1?: number
  U_Val2?: number
  U_Text1?: string
  U_Text2?: string
  U_Text3?: string
  U_Json1?: string
  Role_U_Val1?: number
  Role_U_Val2?: number
  Role_U_Text1?: string
  Role_U_Text2?: string
  Role_U_Text3?: string
  Role_U_Json1?: string
}

let columns: { [key in keyof UserAdministration_UserRoleType]: SYSColumnDef } =
  {
    Grp: {
      sortable: true,
      filter: { columnFilter: { type: "none" } },
      schema: { isCalculatedColumn: true },
      ui: { visibility: "Table" },
    },
    U_RoleCode: {
      sortable: true,
      ui: { labelTranslationKey: "SYSUserAdministrationColRole" },
      list: {
        displayField: "U_RoleCode",
        valueField: "U_RoleCode",
        displayValueField: true,
      },
    },
    U_RoleDesc: {
      control: "textarea",
      ui: {
        labelTranslationKey: "SYSUserAdministrationColRoleDesc",
        visibility: "Table_Edit_View",
        readonly: true,
        expandTableCellOnClick: true,
      },
    },
    U_Json1: {
      control: "textarea",
      ui: {
        labelTranslationKey: "SYSUserAdministrationColRoleJson1",
        align: "center",
        expandTableCellOnClick: true,
      },
    },

    U_Val1: {
      type: "decimal",
      ui: {
        labelTranslationKey: "SYSUserAdministrationColRoleVal1",
      },
    },
    U_Val2: {
      type: "decimal",
      ui: {
        labelTranslationKey: "SYSUserAdministrationColRoleVal2",
      },
    },
    U_Text1: {
      ui: {
        labelTranslationKey: "SYSUserAdministrationColRoleText1",
        align: "center",
        expandTableCellOnClick: true,
      },
    },
    U_Text2: {
      ui: {
        labelTranslationKey: "SYSUserAdministrationColRoleText2",
        align: "center",
        expandTableCellOnClick: true,
      },
    },
    U_Text3: {
      ui: {
        labelTranslationKey: "SYSUserAdministrationColRoleText3",
        align: "center",
        expandTableCellOnClick: true,
      },
    },
  }

export let tblUserAdministration_UserRole: SYSTableDef = {
  id: "SYSUserAdministration_UserRole",
  feature: "SYSUserAdministration",
  permission: "SYSUR",
  database: {
    dataIdField: "Id",
    dbInsertMode: "AutoIdentity",
  },

  server: {
    endpoint: "useradministration/userrole",
  },
  options: {
    navType: "custom",
    initial_sortCustom: {
      selected: "RoleMain",
      sorts: {
        RoleMain: {
          showInTitle: false,
          translationKey: "SYSUserAdministrationRoleMainSort",
        },
      },
    },
    initial_paging: { page: 0, pageSize: 200 },
    customRowActions: {
      HandleRolePermission: {
        icon: "sap-icon--permission",
        translationKey: "SYSUserAdministrationHandleRolePermission",
        permission: "SYSPA",
      },
    },
  },
  features: {
    autoCloseButtonIfInsideDialog: true,
    page: true,
    showFooterButtons: true,
    add: true,
    delete: true,
    edit: true,
  },
  columns,
}
